/**
 * Mentions légales — FR (fait foi).
 */
export const legalFr = {
  eyebrow: 'Documents légaux',
  title: 'Mentions légales',
  subtitle:
    "Informations relatives à l'éditeur du site openmeta.tech, à son hébergement et aux modalités de contact, conformément aux articles 6-III de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN).",
  updated: '8 septembre 2026',
  seoTitle: 'Mentions légales — OpenMeta',
  seoDescription:
    "Mentions légales du site openmeta.tech : éditeur, siège social, capital, immatriculation, TVA, hébergeur, contact.",
  sections: [
    {
      id: 'editeur',
      title: "Éditeur du site",
      blocks: [
        {
          type: 'p',
          content:
            "Le site openmeta.tech est édité par OPENMETA, société par actions simplifiée (SAS) au capital de 40 000 €.",
        },
        {
          type: 'ul',
          content: [
            "Siège social : 5037 Chemin de la Veillotière, 61330 Ceaucé, France.",
            "RCS Alençon : 978 390 813.",
            "Numéro d'identification européen : FR6101.978390813.",
            "Téléphone : +33 2 59 16 64 45.",
            "E-mail : support@openmeta.fr.",
          ],
        },
      ],
    },
    {
      id: 'directeur',
      title: 'Directeur de la publication',
      blocks: [
        {
          type: 'p',
          content:
            "Le directeur de la publication est le représentant légal de la société OPENMETA.",
        },
      ],
    },
    {
      id: 'hebergeur',
      title: 'Hébergement',
      blocks: [
        {
          type: 'p',
          content:
            "Hébergement : OVH SAS — 2 rue Kellermann, 59100 Roubaix, France — Tél. : +33 9 72 10 10 07 — www.ovhcloud.com.",
        },
        {
          type: 'p',
          content:
            "Nom de domaine / registrar : Gandi SAS — 63-65 boulevard Masséna, 75013 Paris, France — www.gandi.net.",
        },
      ],
    },
    {
      id: 'propriete',
      title: 'Propriété intellectuelle',
      blocks: [
        {
          type: 'p',
          content:
            "L'ensemble des éléments du site openmeta.tech (structure, code source, textes, illustrations, logos, marques, sons) est protégé par le droit d'auteur et le droit des marques. Toute reproduction, représentation ou diffusion, en tout ou partie, sans autorisation écrite préalable est strictement interdite.",
        },
      ],
    },
    {
      id: 'donnees',
      title: 'Données personnelles',
      blocks: [
        {
          type: 'p',
          content:
            "Le traitement des données personnelles est décrit dans notre Politique de confidentialité, accessible à l'adresse /confidentialite.",
        },
      ],
    },
    {
      id: 'contact',
      title: 'Contact',
      blocks: [
        {
          type: 'p',
          content:
            "Pour toute demande d'information ou signalement : support@openmeta.fr.\nOPENMETA\n5037 Chemin de la Veillotière\n61330 Ceaucé — France\nTéléphone : +33 2 59 16 64 45",
        },
      ],
    },
  ],
};
